import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "./context/AuthContext";
import { Provider } from "react-redux";
import { store } from "./store";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme.js";
import "./index.css"
import { CartProvider } from "./components/Room/CartContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <ThemeProvider theme={theme}>
      <AuthContextProvider>
      <Provider store={store}>
        <BrowserRouter>
          <CartProvider> 
            <App />
          </CartProvider>
        </BrowserRouter>
      </Provider>
    </AuthContextProvider>
     </ThemeProvider>
    
  </React.StrictMode>
);
